import { render, staticRenderFns } from "./movements.vue?vue&type=template&id=4c44716e&"
import script from "./movements.vue?vue&type=script&lang=js&"
export * from "./movements.vue?vue&type=script&lang=js&"
import style0 from "./movements.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports